module.exports = __webpack_public_path__ + "img/202009.84d470eb.png";